import { gql } from '@apollo/client';

export const TARIFFS = gql`
  query tariffs($first: Int, $page: Int) {
    tariffs(first: $first, page: $page) {
      data {
        id
        has_fixed_finish_time
        use_global_discounts
        title
        show_in_shell
        show_in_billing
        is_active
        duration
        per_minute
        pausable
        lifetime
        sort
        highlighted
        is_tracked
        online_booking_enabled
        ean
        use_on_holidays
        schedules {
          start
          end
        }
        sell_schedules {
          start
          end
        }
        price_list {
          host_groups {
            title
            id
          }
          cost_map {
            title
            value
          }
        }
        disable_sale_receipt_printing
      }
    }
  }
`;

export const UPDATE_TARIFF_SORT = gql`
  mutation updateTariffSort($input: [UpdateTariffsSortInput!]) {
    updateTariffSort(input: $input)
  }
`;

export const CREATE_TARIFF = gql`
  mutation createTariff($input: TariffInput!) {
    createTariff(input: $input) {
      id
      title
      duration
      use_global_discounts
      has_fixed_finish_time
      created_at
      is_active
      disable_sale_receipt_printing
    }
  }
`;

export const UPDATE_TARIFF = gql`
  mutation updateTariff($id: Int!, $input: TariffInput!) {
    updateTariff(id: $id, input: $input) {
      id
      title
      duration
      use_global_discounts
      has_fixed_finish_time
      created_at
      is_active
      disable_sale_receipt_printing
    }
  }
`;

export const DELETE_TARIFF = gql`
  mutation deleteTariff($id: Int!) {
    deleteTariff(id: $id) {
      id
      title
      duration
      use_global_discounts
      has_fixed_finish_time
      created_at
      is_active
      disable_sale_receipt_printing
    }
  }
`;

export const GET_TARIFF_FOR_SETTINGS = gql`
  query TariffsForSettings {
    tariffs {
      data {
        id
        title
      }
    }
  }
`;
